import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TrashIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.3687 7.23053C12.6448 7.23053 12.8687 7.45439 12.8687 7.73053C12.8687 7.76909 12.8642 7.80752 12.8554 7.84505L11.3628 14.1886C11.1502 15.092 10.3441 15.7305 9.41597 15.7305H6.58403C5.65593 15.7305 4.84977 15.092 4.6372 14.1886L3.14459 7.84505C3.08135 7.57625 3.24798 7.30707 3.51678 7.24382C3.55431 7.23499 3.59274 7.23053 3.6313 7.23053H12.3687ZM8.5 1.73053C9.88071 1.73053 11 2.84982 11 4.23053H13C13.5523 4.23053 14 4.67825 14 5.23053V5.73053C14 6.00667 13.7761 6.23053 13.5 6.23053H2.5C2.22386 6.23053 2 6.00667 2 5.73053V5.23053C2 4.67825 2.44772 4.23053 3 4.23053H5C5 2.84982 6.11929 1.73053 7.5 1.73053H8.5ZM8.5 3.23053H7.5C6.94772 3.23053 6.5 3.67825 6.5 4.23053H9.5C9.5 3.67825 9.05228 3.23053 8.5 3.23053Z"
		/>
	</svg>
))
